import React from 'react';
import PropTypes from 'prop-types';

import './Bleed.less';

const Bleed = ({ height, width, verticalBleed, horizontalBleed }) => {
  const widestBleed = verticalBleed >= horizontalBleed ? verticalBleed : horizontalBleed;
  const bleedStyle = {
    top: `${verticalBleed}pt`,
    left: `${horizontalBleed}pt`,
    height: `${height - verticalBleed * 2}pt`,
    width: `${width - horizontalBleed * 2}pt`,
    // make bleed outline wider than necessary extra will be hidden by overflow hidden
    outlineWidth: `${widestBleed * 1.5}pt`,
    pointerEvents: 'none',
  };

  if (verticalBleed && horizontalBleed) {
    return (
      <div className="bleed">
        <div className="bleed__inner-wrapper" style={bleedStyle}>
          <div className="graphic">
            <div className="text text--is-underlined">
              Keep content inside this line to ensure it will be printed
            </div>
            <div className="line" />
            <div className="circle" />
          </div>
        </div>
      </div>
    );
  }
  return null;
};

Bleed.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  verticalBleed: PropTypes.number,
  horizontalBleed: PropTypes.number,
};

export default Bleed;



// WEBPACK FOOTER //
// ./src/cards/components/Customization/Preview/Bleed.jsx